<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script setup>
import { computed } from "vue"
import { useStore } from "vuex"
import { getAdyen, isAdyenValid as isAdyenValidRef } from "@/composables/useAdyen"
import { usePayment } from "@/composables/usePayment"
import EPS from "@/components/payment/EPS/index.vue"
import Walley from "@/components/payment/Walley/index.vue"
import Klarna from "@/components/payment/Klarna/index.vue"
import PayPal from "@/components/payment/PayPal/index.vue"
import Trustly from "@/components/payment/Trustly/index.vue"
import { useCart } from "@/app/Checkout/composables/useCart"
import ApplePay from "@/components/payment/ApplePay/index.vue"
import GooglePay from "@/components/payment/GooglePay/index.vue"
import AdyenCard from "@/components/payment/AdyenCard/index.vue"
import AmazonPay from "@/components/payment/AmazonPay/index.vue"
import { useCheckout } from "@/app/Checkout/composables/useCheckout"
import OnlineBanking from "@/components/payment/OnlineBanking/index.vue"
import NBRadioGroup from "@/app/Checkout/components/common/NBRadioGroup/index.vue"

const store = useStore()
const { cart } = useCart()
const adyenInstance = getAdyen()
const { activePaymentMethod } = useCheckout()
const isAdyenValid = isAdyenValidRef
const { amazonPayConfig, getAdyenConfig, setPaymentMethod, availablePaymentMethods, getAmazonPayConfig, getActivePaymentType } = usePayment()

const handlePaymentMethodChange = async ({ service_type }) => {
  await setPaymentMethod(service_type)

  if (service_type === 21) {
    await getAmazonPayConfig()
  } else {
    await getAdyenConfig()
  }
}

const onKeydown = (e, paymentMethod) => {
  if (e.key === 'Enter' || e.key === ' ') {
    e.preventDefault()
    handlePaymentMethodChange(paymentMethod)
  }
}
</script>
